<template>
  <v-combobox
    multiple
    id="municipio-select"
    v-model="filter.municipio"
    item-text="nome"
    item-name="municipioId"
    :items="municipios"
    :label="isGov ? 'Projeto' : 'Município'"
    :placeholder="isGov ? 'Projeto' : 'Município'"
    @change="$emit('changeCity')"
    :return-object="true"
    clearable
  >
    <template slot="no-data">
      Nenhum {{ isGov ? "Projeto" : "Município" }} retornado
    </template>
  </v-combobox>
</template>

<script>
import { cityAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppCityCombobox",
  props: ["filter"],
  mounted() {
    this.loadCities();
  },
  computed: {
    ...mapGetters(["isGov"]),
  },
  methods: {
    loadCities() {
      cityAPI
        .listNames()
        .then((resp) => {
          this.municipios = resp.data;
        })
        .catch();
    },
  },
  data() {
    return {
      municipios: [],
    };
  },
};
</script>
